import {
  SEND_USER_ACCOUNT_RECOVERY_OTP_NOTIFICATION_EMAIL,
  SEND_USER_ACCOUNT_RECOVERY_OTP_NOTIFICATION_SMS,
  VERIFY_ACCOUNT_RECOVERY_EMAIL_OTP,
  CREATE_ACCOUNT_RECOVERY_PASSWORD,
  VERIFY_ACCOUNT_RECOVERY_SMS_OTP,
} from 'constants/actionTypes';

/**
 * Creates an action to send user's Account Recovery OTP notification email
 * @returns {Object} Redux action with type SEND_USER_ACCOUNT_RECOVERY_OTP_NOTIFICATION_EMAIL
 */
export const sendUserAccountRecoveryOTPNotification = () => ({
  type: SEND_USER_ACCOUNT_RECOVERY_OTP_NOTIFICATION_EMAIL,
});

/**
 * Creates an action to send user's Account Recovery SMS OTP notification
 * @returns {Object} Redux action with type SEND_USER_ACCOUNT_RECOVERY_OTP_NOTIFICATION_SMS
 */
export const sendAccountRecoverySMSOTPNotification = () => ({
  type: SEND_USER_ACCOUNT_RECOVERY_OTP_NOTIFICATION_SMS,
});

/**
 * Creates an action to verify user's Account Recovery SMS OTP
 * @param {Object} payload - The payload containing the verification code
 * @returns {Object} Redux action with type VERIFY_ACCOUNT_RECOVERY_SMS_OTP
 */
export const verifyAccountRecoverySMSOTP = ({ code }) => ({
  type: VERIFY_ACCOUNT_RECOVERY_SMS_OTP,
  payload: {
    code,
  },
});

export const verifyAccountRecoveryEmailOtp = ({ code }, { recovery }) => ({
  type: VERIFY_ACCOUNT_RECOVERY_EMAIL_OTP,
  payload: { code },
  meta: { recovery },
});

export const createAccountRecoveryPassword = ({ password }) => ({
  type: CREATE_ACCOUNT_RECOVERY_PASSWORD,
  payload: { password },
});
